var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsentColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 131,
    viewBox: "0 0 139 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 43,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#82B792"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29890_73057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.55 61.6625C64.55 62.3586 63.9699 62.9 63.3125 62.9C62.6164 62.9 62.075 62.3586 62.075 61.6625V60.425C62.075 58.3754 63.6992 56.7125 65.7875 56.7125C67.8371 56.7125 69.5 58.3754 69.5 60.425V60.7344C69.5 61.5465 69.4227 62.3586 69.3453 63.1708L74.0633 61.7399C74.5273 61.5852 74.9914 61.7399 75.3008 62.0493C75.6488 62.3973 75.7648 62.8614 75.6102 63.3254L74.9141 65.375H78.1625C78.8199 65.375 79.4 65.9551 79.4 66.6125C79.4 67.3086 78.8199 67.85 78.1625 67.85H73.2125C72.7871 67.85 72.4391 67.6954 72.207 67.3473C71.975 67.0379 71.8977 66.6125 72.0137 66.2258L72.5164 64.795L68.8426 65.8778C68.3785 67.9274 67.6437 69.8997 66.5996 71.7172L66.0582 72.6454C65.5555 73.5348 64.6273 74.0375 63.6219 74.0375C62.075 74.0375 60.7988 72.8 60.7988 71.2532V68.4688C60.7988 66.8446 61.8816 65.375 63.4672 64.911L66.7156 63.9442C66.909 62.9 66.9863 61.8172 66.9863 60.7344V60.425C66.9863 59.7676 66.4449 59.1875 65.7488 59.1875C65.0914 59.1875 64.5113 59.7676 64.5113 60.425L64.55 61.6625ZM63.3125 68.4688V71.2532C63.3125 71.4465 63.4285 71.5625 63.6219 71.5625C63.7379 71.5625 63.8539 71.5239 63.8926 71.4079L64.434 70.4797C65.1301 69.2809 65.6715 68.0434 66.0582 66.7286L64.1633 67.27C63.6605 67.4247 63.3125 67.9274 63.3125 68.4688ZM58.0531 69.7063H59.6V71.2532C59.6 71.3692 59.6 71.4852 59.6 71.5625H58.0531C57.5117 71.5625 57.125 71.1758 57.125 70.6344C57.125 70.1317 57.5117 69.7063 58.0531 69.7063ZM80.9469 71.5625H68.0691C68.3785 70.9825 68.6879 70.3637 68.9199 69.7063H80.9469C81.4496 69.7063 81.875 70.1317 81.875 70.6344C81.875 71.1758 81.4496 71.5625 80.9469 71.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29890_73057",
    x: 0.875,
    y: 0.462524,
    width: 137.25,
    height: 129.825,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29890_73057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29890_73057",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentColor);
export default __webpack_public_path__ + "static/media/consent-color.815725dc.svg";
export { ForwardRef as ReactComponent };